import { InjectionToken } from '@angular/core';
import sentryInstance from '@sentry/browser';

export type Sentry = typeof sentryInstance;

export const SENTRY = new InjectionToken<Sentry>('Sentry');
